module.exports = "<div class=\"content-wrapper\">\n  <section style=\"position: relative; padding: 1px 1px 0px 10px;\">\n    <h1>\n      <a [routerLink]=\"['/templates/'+template_id+'/metrics/new/']\" ><i class=\"fa fa-fw fa-plus-circle\"></i></a>\n    </h1>\n  </section>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/templates/show-template/show-template.component.html
// module id = ../../../../../src/app/templates/show-template/show-template.component.html
// module chunks = main